import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["inline", "fullWidth", "highlight", "forwardedRef"],
  _excluded2 = ["inline"],
  _excluded3 = ["inline"],
  _excluded4 = ["error", "children"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { COLORS } from "../../constants/colors";
import { GRAY, RED } from "../../constants/colors/hex";
import { Typography } from "../Typography";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _UploadWrapper = styled(function (_ref) {
  var inline = _ref.inline,
    fullWidth = _ref.fullWidth,
    highlight = _ref.highlight,
    forwardedRef = _ref.forwardedRef,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: forwardedRef
  }, rest));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  flex-flow: ", ";\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 430px;\n  width: ", ";\n  /** Made with https://kovart.github.io/dashed-border-generator/ */\n  background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='", "' stroke-width='2' stroke-dasharray='9' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e\");\n  border-radius: 8px;\n"])), function (props) {
  return props.inline ? 'row' : 'column';
}, function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, function (props) {
  var strokeColor = props.error ? RED[10] : GRAY[15];
  return encodeURIComponent(props.highlight ? COLORS.primary.hover : strokeColor);
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _IconWrapper = styled(function (_ref2) {
  var inline = _ref2.inline,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  svg {\n    transform: ", ";\n    * {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return props.inline ? 'scale(1.0)' : 'scale(2.0)';
}, GRAY[10]);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _TypographyWrapper = styled(function (_ref3) {
  var inline = _ref3.inline,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  flex: 1;\n  color: ", ";\n"])), function (props) {
  return props.inline ? '8px' : '0px';
}, function (props) {
  return props.inline ? '8px' : '0px';
}, function (props) {
  return props.inline ? '0px' : '16px';
}, function (props) {
  return props.inline ? '0px' : '16px';
}, GRAY[10]);
export var _InputWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n"])));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var HelperTextStyled = styled(function (_ref4) {
  var error = _ref4.error,
    children = _ref4.children,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "legal"
  }, rest), children);
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-left: 16px;\n  color: ", ";\n"])), function (props) {
  return props.error ? RED[10] : GRAY[10];
});